import {createContext, useContext} from 'react';

export const IssuePreviewPopupTypes = {
  NO_TYPE_STATUS_CHANGE: 'NO_TYPE_STATUS_CHANGE',
  TRANSITION: 'TRANSITION',
  CONFIRM_UNLINK: 'CONFIRM_UNLINK'
};

export const CurrentIssuePreviewPopupContext = createContext({
  currentIssuePreviewPopup: null,
  setCurrentIssuePreviewPopup: () => {}
});

const useCurrentIssuePreviewPopup = () => useContext(CurrentIssuePreviewPopupContext);

export default useCurrentIssuePreviewPopup;
